<app-cube-trend-simulator [config]="config"></app-cube-trend-simulator>
